import {h} from "preact";
import { Tooltip } from 'react-tooltip'

export default function NextButton({ text = "Next", onNext, disabled = false, className = "coit-button", tooltipMessage="Please complete all required fields before proceeding." }) {
  return (
    <button
      data-tooltip-id="next-button-tooltip"
      data-tooltip-content={disabled ? tooltipMessage : undefined}
      data-tooltip-place="top"
      onClick={onNext}
      disabled={disabled}
      className={className}
    >
      {text}
      <Tooltip id="next-button-tooltip" className="max-w-2xs z-10"/>
    </button>
  )
}
